import LogEmail from ".";

export const logEmailRoutes = [
  {
    path: "/log-email",
    element: <LogEmail />,
  },
];
